import React from "react";
import { Link } from "react-router-dom";
import { SealCheck } from "@phosphor-icons/react";
import { useLang } from "@/context/LangContext";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="mt-24 border-t border-ppc pb-32 md:pb-0">
      <div className="mx-auto max-w-7xl px-5 py-12 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-center">
          <img src="/plinplincare-wordmark-dark.png" alt="PlinPlinCare" className="h-5 w-auto object-contain" />
          <p className="max-w-sm text-sm text-ppc-muted">{t("footer_tagline")}</p>
        </div>
        <div className="mt-8 flex flex-wrap items-center justify-between gap-3 border-t border-ppc pt-6 text-xs text-ppc-muted">
          <span>© {new Date().getFullYear()} PlinPlinCare. {t("footer_rights")}</span>
          <span className="flex items-center gap-4">
            <Link to="/legal" data-testid="footer-legal-link" className="text-primary-green">Legal</Link>
            <Link to="/legal#privacy" data-testid="footer-privacy-link" className="hover:text-primary-green">Privacy Policy</Link>
            <Link to="/legal#terms" data-testid="footer-terms-link" className="hover:text-primary-green">Terms of Use</Link>
            <Link to="/faq-italia" data-testid="footer-faq-it-link" className="hover:text-primary-green">FAQ Italia 🇮🇹</Link>
            <span className="inline-flex items-center gap-1.5">
              <SealCheck size={14} weight="fill" color="#9184d9" /> Stripe · Verified providers
            </span>
          </span>
        </div>
        <p className="mt-3 text-xs text-ppc-muted" data-testid="footer-legal">
          PlinPlinCare is owned and managed by JamesBass Technologies, a division of JamesBass Holding LLC, Los Angeles, California.
        </p>
      </div>
    </footer>
  );
};
